import styled from 'styled-components';
import { Picture } from '../../fuse-picture/src/picture';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const SquircleSVG =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M50 25c0 18.41-6.59 25-25 25S0 43.41 0 25 6.59 0 25 0s25 6.59 25 25Z"/></svg>';

const StyledQuickFilter = styled.a.attrs({
	className: 'fuse-quick-filter',
})`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: var(--spacing-global-space3); // 8px
	text-decoration: none;
	cursor: pointer;

	&:focus-visible {
		outline: var(--border-width-s) solid var(--color-functional-focus);
	}

	&:focus:not(:focus-visible) {
		outline: none;
	}

	${() => {
		const textDecorationUnderline = (colour) => `
			text-decoration-line: underline;
			text-decoration-color: ${colour};
			text-decoration-style: solid;
			text-decoration-thickness: 1px;
		`;

		return `
			&:hover .fuse-quick-filter__label,
			&:focus .fuse-quick-filter__label {
				color: var(--color-brand-dark);
				${textDecorationUnderline(`var(--color-brand-dark)`)}
			}

			&:active .fuse-quick-filter__label {
				color: var(--color-global-black);
				${textDecorationUnderline(`var(--color-global-black)`)}
			}
		`;
	}};
`;

const StyledImage = styled(Picture)
	.withConfig({ shouldForwardProp: (prop) => prop !== 'imageLink' })
	.attrs({
		className: 'fuse-quick-filter__image',
		'data-testid': 'fuse-quick-filter-image-test-id',
	})`
	margin: 0;

	@media screen and (min-width: ${gridConfig.l.minWidth}) {
		margin: var(--spacing-global-space1) var(--spacing-global-space1) 0 var(--spacing-global-space1);
	}

	& .fuse-picture__img {
		aspect-ratio: 1/1;
		object-fit: cover;
		mask: url('data:image/svg+xml, ${encodeURIComponent(SquircleSVG)}') center/cover no-repeat;
		-webkit-mask: url('data:image/svg+xml, ${encodeURIComponent(SquircleSVG)}') center/cover
			no-repeat;
		width: 100%;
	}
`;

const StyledLabel = styled(TypographyComponent).attrs({
	className: 'fuse-quick-filter__label',
	'data-testid': 'fuse-quick-filter-label-test-id',
	size: '1',
	type: 'paragraph',
})`
	color: var(--color-global-grey1000);
	text-align: center;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-height: var(--spacing-global-space6); //24
	max-height: var(--spacing-global-space9); //48
	margin-bottom: 0;
`;

export { StyledImage, StyledLabel, StyledQuickFilter };
